
import axiosClient from "@/api/axios"
import { computed, onBeforeUnmount, onMounted, ref, watchEffect } from "vue";
import { business, restaurant, addOns, cart, deliveryType, apiBaseUrl, tableNumber, isLoading, hideNav } from '@/global/state/GlobalState'
import { isQrcodeReaderOpen, isNotificationsModalOpen } from '@/global/state/ModalState'
import { customer, isAuthModalOpen } from "@/global/state/AuthState";
import MyModal from "@/components/modal/MyModal.vue";
import CartSidebar from './components/CartSidebar.vue'
import FooterComponent from './components/FooterComponent.vue'
import AuthModal from "./components/AuthModal.vue";
import NotificationsModal from "./components/NotificationsModal.vue";
import { QrcodeStream } from 'vue-qrcode-reader'
import { useToast } from "vue-toastification";
import '../../../services/firebase'
import CustomerRequestModal from "./components/CustomerRequestModal.vue";
import { showNotification, notification, notifications, clearNotifications } from '../../../global/state/NotificationState'
import CentralLoader from '@/components/loaders/CentralLoader.vue'
import { onInputSearch, searchRegex } from "@/global/state/SearchState";
import { useRoute } from "vue-router";
import { storefront, storefrontTemplate, normalizeStorefront, loadStorefrontFonts, FONT_FAMILIES, RADIUS_VALUES, STOREFRONT_TEMPLATES, TEMPLATE_BACKGROUNDS, isDarkColor, mixColors, readableTextOn, contrastRatio, DARK_SURFACE_TEXT, LIGHT_SURFACE_TEXT } from "@/global/state/StorefrontState";
import '@/global/css/storefront.css'

const __default__ = {
    name:'web-layout', 
    components: {
        MyModal,
        CartSidebar,
        AuthModal,
        QrcodeStream,
        NotificationsModal,
        CustomerRequestModal,
        CentralLoader,
        FooterComponent
    },
    setup(){
        const isMenuOpen = ref<boolean>(false)
        const isCartOpen = ref<boolean>(false)
        const isInfoModalOpen = ref<boolean>(false)
        const currentInfoSection = ref<'about' | 'operating_hours' | 'social_media'>('about')
        const isCustomerRequestModal = ref<boolean>(false)
        const isInstallPwaModalOpen = ref<boolean>(false)
        const isMenuDropdownOpen = ref<boolean>(false)
        const designCustom = ref<any>({
            logo:'',
            primaryColor:''
        })
        const searchQuery = ref<string>('')
        const isScrolled = ref<boolean>(false)
        const toast = useToast()
         const days = {
            1: 'Segunda-feira',
            2: 'Terça-feira',
            3: 'Quarta-feira',
            4: 'Quinta-feira',
            5: 'Sexta-feira',
            6: 'Sábado',
            7: 'Domingo'
        };
        const dayKeyMap: any = {
            1: 'monday',
            2: 'tuesday',
            3: 'wednesday',
            4: 'thursday',
            5: 'friday',
            6: 'saturday',
            7: 'sunday'
        };
        const daysFormat: any = {
            0: 'Domingo',
            1: 'Segunda-feira',
            2: 'Terça-feira',
            3: 'Quarta-feira',
            4: 'Quinta-feira',
            5: 'Sexta-feira',
            6: 'Sábado'
        };
        const getDay = new Date().getDay()
        const today: string = daysFormat[getDay]
        const route = useRoute()

        const enabledOrderTypes = computed<string[]>(() => {
            const fromConfig = (restaurant.value as any)?.restaurantConfig?.enabledOrderTypes
            if (Array.isArray(fromConfig) && fromConfig.length > 0) return fromConfig
            return ['delivery', 'pick_up', 'waiter']
        })
        const isWaiterEnabled = computed<boolean>(() => enabledOrderTypes.value.includes('waiter'))

        function onDecode(code: any){
            let arrayCode = code[0].rawValue.split('?')
            let parameter = arrayCode[1].split('=')
            let commandNumber = parameter[1]

            if(parameter[0] == 'command' && commandNumber){
                localStorage.setItem('table_number', commandNumber)
                tableNumber.value = commandNumber
                toast.success('Comanda registrada para a mesa ' + commandNumber, { timeout: 2000 })
                isQrcodeReaderOpen.value = false
            } else{
                toast.error('Qrcode inválido!', { timeout: 1500 })
            }
        }
        let searchOffsetTop = 1
        function handleScroll() {
            isScrolled.value = window.scrollY > 0;
            const searchElement = document.querySelector('.web-layout__search') as HTMLElement
            
            if(searchElement){
                if(searchElement.offsetTop > 0){
                    searchOffsetTop = searchElement.offsetTop
                }
                if(window.scrollY >= searchOffsetTop){
                    searchElement?.classList.add('fixed')
                } else{
                    searchElement?.classList.remove('fixed')
                }
            }
        }

        function selectDeliveryType(){
            if(deliveryType.value){
                localStorage.setItem('deliveryType', deliveryType.value)
            }

            isMenuOpen.value = false
        }

        function clearSearchProduct(){
            searchQuery.value = ''
            searchRegex.value = new RegExp(`.*.*`, 'i')
            let searchInput = document.querySelector('#search-products')! as HTMLElement
            searchInput.focus()
        }

        function logout(){
            clearNotifications()
            localStorage.removeItem('customer'); 
            localStorage.removeItem('table_number'); 
            notifications.value = []
            customer.value = {}; 
            toast.success('Deslogado com sucesso.', { timeout:2000 })
            isMenuOpen.value = false
        }

        const unreadNotificationsLength = computed(() => {
            return notifications.value.filter((n: any) => !n.isRead).length
        })

        let deferredPrompt = ref<any>();

        function showInstallAlert() {
            const lastPromptDate: string | null = localStorage.getItem('pwaPromptLastShown');
            const now = new Date();

            if (!lastPromptDate || (now.getTime() - new Date(lastPromptDate).getTime()) > 15 * 24 * 60 * 60 * 1000) {
                isInstallPwaModalOpen.value = true;
                localStorage.setItem('pwaPromptLastShown', now.toISOString());
            }
        }

        function installPWA() {
            if (deferredPrompt.value) {
                deferredPrompt.value.prompt();
                deferredPrompt.value.userChoice.then(() => {
                    deferredPrompt.value = null;
                    isInstallPwaModalOpen.value = false;
                });
            }
        }
        const documentOnClick = (e: any) => {
            const menuDropdown = document.getElementById('menu_dropdown') as HTMLElement;
            if(e.target?.id != 'menu_dropdown' && !menuDropdown?.contains(e.target) && isMenuDropdownOpen.value){
                isMenuDropdownOpen.value = false
            }
        }

        onMounted(() => {
            if(!tableNumber.value){
                if(route.query.command){
                    tableNumber.value = parseInt(route.query.command as string)
                    localStorage.setItem('table_number', route.query.command as string)
                }
            }
            document.addEventListener('click', documentOnClick)
            axiosClient.get('/customer/config')
            .then((res) => {
                business.value = res.data.business;
                restaurant.value = res.data.restaurant;
                restaurant.value.banners = res.data.banners;
                const customizations = res.data.restaurant.customizations || []
                const design: any = {}
                customizations.forEach((c: any) => {
                    if (c.type === 'theme') {
                        design.primaryColor = c.primaryColor
                        design.secondaryColor = c.secondaryColor
                    } else if (c.type === 'menu') {
                        design.menuTextColor = c.textColor
                        design.menuTextHoverColor = c.textHoverColor
                        design.menuFixed = c.fixedMenu
                    } else if (c.type === 'footer') {
                        design.footerBackgroundColor = c.backgroundColor
                        design.footerTextColor = c.textColor
                    } else if (c.type === 'logo') {
                        design.logo = c.logo
                        design.pwaLogo = c.pwaLogo
                    }
                })
                // Older APIs don't send `storefront`: normalizeStorefront falls back to the default (today's layout)
                storefront.value = normalizeStorefront(res.data.storefront)
                // Storefront palette overrides the theme colors at the source, so every legacy
                // consumer (.text-primary/.bg-primary, cart, modals, footer accents) follows it.
                const sfColors = storefront.value.settings.colors
                if (sfColors.primary) design.primaryColor = sfColors.primary
                if (sfColors.secondary) design.secondaryColor = sfColors.secondary
                designCustom.value = design
                restaurant.value.restaurantDesignCustom = design // Sincroniza para os componentes que usam restaurant.restaurantDesignCustom
                addOns.value = res.data.addOns

                const link = document.createElement('link');
                link.type = 'image/x-icon';
                link.rel = 'icon';
                link.href = restaurant.value.favIcon ? `${apiBaseUrl}/storage/${restaurant.value.favIcon}`:'/assets/favicon.png';

                const themeMeta = document.createElement('meta');
                themeMeta.name = 'theme-color'
                themeMeta.content =  res.data.restaurant.restaurantDesignCustom.primaryColor;
                document.head.appendChild(themeMeta);

                if (restaurant.value.restaurantConfig?.metaDescription) {
                    const metaDescription = document.createElement('meta');
                    metaDescription.name = 'description';
                    metaDescription.content = restaurant.value.restaurantConfig?.metaDescription;

                    document.head.appendChild(metaDescription);
                }

                if (restaurant.value.restaurantConfig?.metaImage) {
                    const metaImage = document.createElement('meta');
                    metaImage.name = 'og:image';
                    metaImage.content = `${apiBaseUrl}/storage/restaurant/${restaurant.value.restaurantConfig?.metaImage}`;

                    document.head.appendChild(metaImage);
                }
                document.querySelector('title')?.remove()
                const title = document.createElement('title');
                title.innerHTML = restaurant.value.name

                document.head.appendChild(link);
                document.head.appendChild(title);
                window.addEventListener('beforeinstallprompt', (e) => {
                    e.preventDefault();
                    deferredPrompt.value = e;
                    showInstallAlert();
                });
            }).catch((error) => {
                console.log(error)
            });
            
            if(customer.value.cpf){
                const cleanCpf = customer.value.cpf.replace(/\D/g, '')
                axiosClient.get(`/customer/cpf/${cleanCpf}`)
                .then((res:any) => {
                    const updatedCustomer = { ...customer.value, ...res.data.customer, is_registered: true }
                    localStorage.setItem('customer', JSON.stringify(updatedCustomer))
                    customer.value = updatedCustomer
                }).catch(() => {
                    const updatedCustomer = { ...customer.value, is_registered: false }
                    localStorage.setItem('customer', JSON.stringify(updatedCustomer))
                    customer.value = updatedCustomer
                })
            }

            window.addEventListener('scroll', handleScroll);
        });

        // Storefront theme plumbing: template class + CSS variables on <html> so that
        // teleported/fixed elements (modals, cart sidebar, body background) can be styled too.
        const stopThemeEffect = watchEffect(() => {
            const root = document.documentElement
            const template = storefront.value.template
            const settings = storefront.value.settings
            STOREFRONT_TEMPLATES.forEach((t) => root.classList.remove(`sf-template-${t}`))
            root.classList.add(`sf-template-${template}`)
            const colors = settings.colors
            const primary = colors.primary || designCustom.value?.primaryColor || '#323232'
            const secondary = colors.secondary || designCustom.value?.secondaryColor || primary
            root.style.setProperty('--sf-primary', primary)
            root.style.setProperty('--sf-secondary', secondary)
            root.style.setProperty('--sf-on-primary', readableTextOn(primary))
            root.style.setProperty('--sf-on-secondary', readableTextOn(secondary))
            root.style.setProperty('--sf-font', FONT_FAMILIES[settings.font]?.css ?? FONT_FAMILIES.inter.css)
            root.style.setProperty('--sf-radius', RADIUS_VALUES[settings.radius] ?? RADIUS_VALUES.medium)

            // Background/text overrides. Inline vars on <html> win over the template rules
            // (html.sf-template-*), and `sf-dark` switches the dark chrome on whenever the
            // effective background is dark (dark template or a dark custom background).
            const background = colors.background || TEMPLATE_BACKGROUNDS[template]
            const dark = isDarkColor(background)
            root.classList.toggle('sf-dark', dark)
            root.classList.toggle('sf-custom-bg', !!colors.background)
            const setOrClear = (name: string, value: string | null) => {
                if (value) root.style.setProperty(name, value)
                else root.style.removeProperty(name)
            }
            setOrClear('--sf-bg', colors.background)
            setOrClear('--sf-card-bg', colors.background ? (dark ? mixColors(colors.background, '#ffffff', 0.07) : (template === 'minimal' ? colors.background : '#ffffff')) : null)
            setOrClear('--sf-border', colors.background ? mixColors(colors.background, dark ? '#ffffff' : '#000000', dark ? 0.14 : 0.1) : null)
            setOrClear('--sf-skeleton', colors.background && dark ? mixColors(colors.background, '#ffffff', 0.12) : null)
            // Only the background overridden: if the template text would be hard to read on it
            // (contrast < 3:1), switch to black or white automatically.
            const templateText = dark ? DARK_SURFACE_TEXT : LIGHT_SURFACE_TEXT
            const text = colors.text || (colors.background && contrastRatio(templateText, colors.background) < 3 ? readableTextOn(colors.background) : null)
            setOrClear('--sf-text', text)
            setOrClear('--sf-muted', text ? mixColors(text, background, 0.35) : null)
            loadStorefrontFonts(template === 'minimal' ? [settings.font, 'playfair'] : [settings.font])
        })

        onBeforeUnmount(() => {
            stopThemeEffect()
            window.removeEventListener('scroll', handleScroll);
            document.removeEventListener('click',documentOnClick);
        });

        return {
            isCartOpen,
            business,
            designCustom,
            restaurant,
            isScrolled,
            isMenuOpen,
            deliveryType,
            selectDeliveryType,
            searchQuery,
            cart,
            isQrcodeReaderOpen,
            onDecode,
            apiBaseUrl,
            isInfoModalOpen,
            currentInfoSection,
            isNotificationsModalOpen,
            days,
            dayKeyMap,
            today,
            isCustomerRequestModal,
            customer,
            logout,
            isAuthModalOpen,
            tableNumber,
            isWaiterEnabled,
            showNotification,
            notification,
            notifications,
            unreadNotificationsLength,
            installPWA,
            isInstallPwaModalOpen,
            deferredPrompt,
            isMenuDropdownOpen,
            clearSearchProduct,
            isLoading,
            onInputSearch, 
            hideNav,
            storefrontTemplate
        }
    },
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "06eba086": (_ctx.designCustom?.primaryColor),
  "497a76ea": (_ctx.designCustom?.secondaryColor),
  "58045bd4": (_ctx.designCustom.menuTextColor),
  "6880f0b4": (_ctx.designCustom.menuTextHoverColor),
  "0a5530a0": (_ctx.designCustom.secondaryColor),
  "c3754fbc": (_ctx.designCustom.primaryColor)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__